export default __webpack_public_path__ + "static/media/EcllipseLeftBottom.7c768839.svg";